// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_ADD_QUESTION = "Op\u00fdtaj sa v poradni";
export const STROLLER_BRAND_LINKED_ARTICLES_OF_brand = "\u010cl\u00e1nky a recenzie ko\u010d\u00edkov %(brand)s";
export const STROLLER_BRAND_LINKED_OBJECTS_OF_brand = "Ot\u00e1zky v poradni ku ko\u010d\u00edkom %(brand)s";
export const STROLLER_MORE_ABOUT_BRAND = "Viac o zna\u010dke";
export const STROLLER_OFFICIAL_SITE_link = "Ofici\u00e1lna str\u00e1nka %(link)s";
export const STROLLERS_NO_RESULTS = "Nena\u0161li sme \u017eiadne ko\u010d\u00edky.";
export const STROLLERS_SEARCH_HOMEPAGE_BTN_TITLE = "N\u00e1jdi ko\u010d\u00edk pod\u013ea svojich predst\u00e1v";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00edkop\u00e9dia";
